<div>
  <form [formGroup]="timeGraphForm" (ngSubmit)="onSubmit()">
    <mat-dialog-content>
      <p>
        Здравствуйте! В скором времени вам предстоит пройти последний этап
        обучения в Attractor School - блок работы в команде (ESDP). Заполните
        график занятости, для более комфортного разделения рабочего времени
        команды.
      </p>
      <p>Выберите часы, в которые вам удобнее всего уделять время работе:</p>
      <div>
        <mat-selection-list>
          <mat-list-option
            *ngFor="let type of types | keyvalue"
            (click)="toggleSelectionTimes(type.value)"
            [selected]="isSelectTime(type.value)"
            [value]="type.value">
            {{ type.key }}
          </mat-list-option>
        </mat-selection-list>
      </div>
    </mat-dialog-content>

    <div mat-dialog-actions class="justify-content-end">
      <app-button-with-progress
        *ngIf="this.student?.free_time_form.postpone_count !== 3 && !isEdit"
        typeBtn="button"
        class="mr-2"
        label="Напомнить позже"
        matColor="white"
        (clickHandler)="remindLater()"
        [loading$]="
          (sendLoading$ | async) || profileLoading$
        "></app-button-with-progress>

      <button
        *ngIf="isEdit"
        mat-raised-button
        class="mr-2"
        type="button"
        (click)="onCancel()">
        Отмена
      </button>

      <app-button-with-progress
        typeBtn="submit"
        label="Сохранить"
        [loading$]="
          (sendLoading$ | async) || profileLoading$
        "></app-button-with-progress>
    </div>
  </form>
</div>
